<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <staff-check-out-page /><br><br><br>
    </div>
  </div>
</template>

    <script>
    import StaffCheckOutPage from '../../../Components/Staff/StaffCheckOutPage.vue';
      export default {
        name: 'StaffCheckOutPage',
        components: {
          'staff-check-out-page': StaffCheckOutPage,
      },
    };
    </script>

    <style scoped>

    </style>
